import { render, staticRenderFns } from "./SignCanvas.vue?vue&type=template&id=70fabb4e&scoped=true"
import script from "./SignCanvas.vue?vue&type=script&lang=js"
export * from "./SignCanvas.vue?vue&type=script&lang=js"
import style0 from "./SignCanvas.vue?vue&type=style&index=0&id=70fabb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fabb4e",
  null
  
)

export default component.exports